module.exports = __webpack_public_path__ + "img/Cobertura de Autopartes.ce299ccd.svg";